import {
  actionTypes,
} from 'redux-resource';
import {
  ResourceType,
} from '../../types';

/*
 * multiLists: {
 *  [resourceType]: {
 *    [listsName]: Array[ids],
 *    [listsName]: Array[ids],
 *  }
 * }
 * */
const multiListPlugin = (resourceType: ResourceType) => (state, action) => {
  const {
    type,
    multiLists,
  } = action;

  if ([
    actionTypes.READ_RESOURCES_SUCCEEDED,
    actionTypes.READ_RESOURCES_FAILED,
    actionTypes.CREATE_RESOURCES_SUCCEEDED,
    actionTypes.UPDATE_RESOURCES_SUCCEEDED,
    actionTypes.DELETE_RESOURCES_SUCCEEDED,
  ].includes(type)) {
    if (!multiLists) {
      return state;
    }

    const resourceTypes = Object.keys(multiLists);
    if (!resourceTypes.includes(resourceType)) {
      return state;
    }

    return {
      ...state,
      lists: {
        ...state.lists,
        ...multiLists[resourceType],
      },
    };
  }

  return state;
};

export default multiListPlugin;
